/* @flow */

export default class AddSupplierContactPersonRequest {
    companyId: number;
    supplierCompanyId: number;
    titleId: number;
    lastName: string;
    firstName: string;
    email: string;
    languageId: number;
    functionName: string;

    
    constructor(companyId: number, supplierCompanyId: number, titleId: number, lastName: String, firstName: String, email:String, languageId: number, functionName:String) {
      this.companyId = companyId;
      this.supplierCompanyId = supplierCompanyId;
      this.titleId = titleId;
      this.lastName = lastName;
      this.firstName = firstName;
      this.email = email;
      this.languageId = languageId;
      this.functionName = functionName;
    }
  }
  